import * as THREE from 'three';

/**
 * A seamless studio dome with no light panels or hotspots, so metals pick up
 * even tone without any visible reflected shapes.
 */
export function createSoftEnvironment(renderer: THREE.WebGLRenderer): {
  texture: THREE.Texture;
  dispose: () => void;
} {
  const envScene = new THREE.Scene();
  const geometry = new THREE.SphereGeometry(10, 64, 32);
  const top = new THREE.Color('#c9ccd4');
  const horizon = new THREE.Color('#8a8d96');
  const bottom = new THREE.Color('#34363c');
  const colors: number[] = [];
  const pos = geometry.attributes.position;
  const c = new THREE.Color();

  for (let i = 0; i < pos.count; i++) {
    const y = pos.getY(i) / 10; // -1..1
    if (y >= 0) c.copy(horizon).lerp(top, Math.pow(y, 0.7));
    else c.copy(horizon).lerp(bottom, Math.pow(-y, 0.6));
    colors.push(c.r, c.g, c.b);
  }
  geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));

  const material = new THREE.MeshBasicMaterial({ vertexColors: true, side: THREE.BackSide });
  envScene.add(new THREE.Mesh(geometry, material));

  const pmrem = new THREE.PMREMGenerator(renderer);
  const texture = pmrem.fromScene(envScene, 0.06).texture;

  return {
    texture,
    dispose: () => {
      texture.dispose();
      pmrem.dispose();
      geometry.dispose();
      material.dispose();
    },
  };
}
